import React from "react";
import { AboutCompany } from "./AboutCompany";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { TermsOfService } from "./TermsOfService";
import { PlatformRules } from "./PlatformRules";
import { RefundPolicy } from "./RefundPolicy";
import { PerformerAgreement } from "./PerformerAgreement";
import { Contacts } from "./Contacts";
import { SiteFooter, HtmlSitemap } from "../../components/SiteFooter";

// D1: каждый юрдокумент — отдельная страница с постоянным адресом /legal/<slug>
export const LEGAL_PAGES = {
  offer: { title: "Публичная оферта", view: "terms", Component: TermsOfService },
  privacy: { title: "Политика конфиденциальности", view: "privacy", Component: PrivacyPolicy },
  rules: { title: "Правила платформы", view: "platform-rules", Component: PlatformRules },
  refund: { title: "Возврат и обмен", view: "refund-policy", Component: RefundPolicy },
  performer: { title: "Соглашение исполнителя", view: "performer-agreement", Component: PerformerAgreement },
  requisites: { title: "О компании и реквизиты", view: "about", Component: AboutCompany },
  contacts: { title: "Контакты", view: "contacts", Component: Contacts },
  sitemap: { title: "Карта сайта", view: null, Component: HtmlSitemap },
};

const VIEW_TO_SLUG = Object.fromEntries(Object.entries(LEGAL_PAGES).filter(([, p]) => p.view).map(([slug, p]) => [p.view, slug]));
const LEGACY_PATHS = {
  "/privacy": "privacy", "/privacy-policy": "privacy", "/terms": "offer", "/oferta": "offer", "/offer": "offer",
  "/rules": "rules", "/refund": "refund", "/contacts": "contacts", "/about": "requisites", "/requisites": "requisites",
  "/sitemap": "sitemap", "/legal": "offer", "/legal/": "offer",
};

export const legalPath = (view) => (VIEW_TO_SLUG[view] ? `/legal/${VIEW_TO_SLUG[view]}` : null);

// Редиректы со старых адресов (/privacy, /oferta, ?view=privacy и т.п.) на постоянные /legal/<slug>
export const applyLegacyLegalRedirect = () => {
  const { pathname, search } = window.location;
  const params = new URLSearchParams(search);
  const legacy = LEGACY_PATHS[pathname.replace(/\/+$/, "") || pathname] || (pathname === "/" && VIEW_TO_SLUG[params.get("view")]);
  if (legacy) window.history.replaceState({}, "", `/legal/${legacy}`);
};

export const getLegalSlug = (pathname) => {
  const m = /^\/legal\/([a-z-]+)\/?$/.exec(pathname || "");
  return m && LEGAL_PAGES[m[1]] ? m[1] : null;
};

export const LegalPage = ({ slug, user }) => {
  const page = LEGAL_PAGES[slug];
  const { Component } = page;
  React.useEffect(() => { document.title = `${page.title} — Реверсия`; }, [page.title]);
  const navigate = (view) => { window.location.href = legalPath(view) || (view && view !== "home" ? `/?view=${view}` : "/"); };
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--rv-paper)" }} data-testid={`legal-page-${slug}`}>
      <header className="w-full" style={{ background: "var(--rv-navy)" }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <a href="/" className="flex items-center gap-2 text-white font-bold" style={{ fontFamily: "Manrope,sans-serif", textDecoration: "none" }} data-testid="legal-home-link">
            <img src="/images/logo.png" alt="" className="w-8 h-8 rounded-md object-contain" style={{ background: "rgba(255,255,255,0.1)", padding: 3 }} onError={(e) => { e.target.style.display = "none"; }} />
            Реверсия
          </a>
          <a href="/" className="text-sm" style={{ color: "rgba(255,255,255,0.75)" }} data-testid="legal-back-link">
            {user ? "Вернуться в приложение" : "На главную"}
          </a>
        </div>
      </header>
      <main className="flex-1 w-full max-w-5xl mx-auto px-3 sm:px-6 py-8">
        <Component setCurrentView={navigate} />
      </main>
      <SiteFooter />
    </div>
  );
};
